<template>
  <div v-bind="$attrs" v-html="values"></div>
</template>

<script>

export default {
  components: {},
  props: {
    value:{
      type: String,
      default: ''
    }
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {
    values:{
      get(){
        return this.value
      },
      set(val){
        this.$emit('input',val)
      }
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  beforeDestroy() {
  },
  destroyed() {
  },
}

</script>

<style scoped lang="scss">

</style>

